const fonts = {
  body: '"Muli", sans-serif',
  heading: '"Muli", sans-serif',
  mono: '"Muli", sans-serif',
};

export default fonts;
